import { useContext } from "react"

import Toast from "@/context/ToastContext"

export const useToast = () => {
  return useContext(Toast)
}

export default useToast
